import React from 'react'
import type { RowBlock as BlockProps } from '@/payload-types'
import { RenderBlocks } from '@/blocks/RenderBlocks'
import { cn } from '@/utilities/cn'

const GAP_CLASS: Record<string, string> = {
  none: 'gap-0',
  xs: 'gap-1',
  sm: 'gap-2',
  md: 'gap-4',
  lg: 'gap-8',
  xl: 'gap-16',
}
const JUSTIFY_CLASS: Record<string, string> = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
  between: 'justify-between',
  around: 'justify-around',
  evenly: 'justify-evenly',
}
const ALIGN_CLASS: Record<string, string> = {
  start: 'items-start',
  center: 'items-center',
  end: 'items-end',
  stretch: 'items-stretch',
  baseline: 'items-baseline',
}
const WRAP_CLASS: Record<string, string> = {
  nowrap: 'flex-nowrap',
  wrap: 'flex-wrap',
}

export const RowBlock: React.FC<BlockProps> = ({ layout, gap, justify, align, wrap }) => {
  return (
    <div
      className={cn(
        'flex flex-row',
        GAP_CLASS[gap || 'md'],
        JUSTIFY_CLASS[justify || 'start'],
        ALIGN_CLASS[align || 'center'],
        WRAP_CLASS[wrap || 'wrap'],
      )}
    >
      <RenderBlocks blocks={layout ?? []} />
    </div>
  )
}
